"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { cn } from "@/utils/cn";
interface ButtonActions {
  label?: string;
  next?: boolean;
  onBack?: () => void;
  onNext?: () => void;
  disabled?: boolean;
  backTitle?: string;
  disableBack?: boolean;
  isLoading?: boolean;
}
export function ButtonActions(t0) {
  const $ = _c(25);
  const {
    label,
    next: t1,
    onBack,
    onNext,
    backTitle,
    disabled,
    disableBack: t2,
    isLoading: t3
  } = t0;
  const next = t1 === undefined ? false : t1;
  const disableBack = t2 === undefined ? false : t2;
  const isLoading = t3 === undefined ? false : t3;
  const isButtonDisabled = disabled || isLoading;
  if (!onBack && !next && label) {
    let t4;
    if ($[0] !== backTitle) {
      t4 = backTitle ? {
        title: backTitle
      } : {};
      $[0] = backTitle;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    const t5 = isButtonDisabled ? "bg-neutral-200 text-neutral-400 border border-neutral-200 shadow-none cursor-not-allowed" : "bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800 shadow-sm hover:shadow-md";
    let t6;
    if ($[2] !== t5) {
      t6 = cn("w-full h-12 px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-200 flex items-center justify-center gap-2", t5);
      $[2] = t5;
      $[3] = t6;
    } else {
      t6 = $[3];
    }
    let t7;
    if ($[4] !== isLoading) {
      t7 = isLoading && <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg>;
      $[4] = isLoading;
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    let t8;
    if ($[6] !== isButtonDisabled || $[7] !== label || $[8] !== t4 || $[9] !== t6 || $[10] !== t7) {
      t8 = <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm p-2 sm:p-6 lg:sticky lg:bg-white lg:backdrop-blur-none lg:-mx-6 lg:-mb-6 z-20"><div className="max-w-md mx-auto lg:max-w-none"><Button isDisabled={isButtonDisabled} type="submit" {...t4} className={t6}>{t7}{label}</Button></div></div>;
      $[6] = isButtonDisabled;
      $[7] = label;
      $[8] = t4;
      $[9] = t6;
      $[10] = t7;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    return t8;
  }
  let t4;
  if ($[12] !== backTitle || $[13] !== disableBack || $[14] !== isLoading || $[15] !== onBack) {
    t4 = onBack && <Button type="button" isDisabled={disableBack || isLoading} variant="outline" {...onBack ? {
      onClick: onBack
    } : {}} {...backTitle ? {
      title: backTitle
    } : {}} className={cn("flex-1 h-12 px-6 py-3 border-neutral-300 text-neutral-700 rounded-lg font-semibold text-sm hover:bg-neutral-50 active:bg-neutral-100 transition-all duration-200", disableBack || isLoading ? "cursor-not-allowed" : "")}>Back</Button>;
    $[12] = backTitle;
    $[13] = disableBack;
    $[14] = isLoading;
    $[15] = onBack;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== isButtonDisabled || $[18] !== isLoading || $[19] !== next || $[20] !== onNext) {
    t5 = next && <Button isDisabled={isButtonDisabled} type={onNext ? "button" : "submit"} onClick={onNext} className={cn("flex-1 h-12 px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-200 flex items-center justify-center gap-2", isButtonDisabled ? "bg-neutral-200 text-neutral-400 border border-neutral-200 shadow-none cursor-not-allowed" : "bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800 shadow-sm hover:shadow-md")}>{isLoading && <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg>}Next</Button>;
    $[17] = isButtonDisabled;
    $[18] = isLoading;
    $[19] = next;
    $[20] = onNext;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t4 || $[23] !== t5) {
    t6 = <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm p-2 sm:p-6 lg:sticky lg:bg-white lg:backdrop-blur-none lg:-mx-6 lg:-mb-6 z-20"><div className="max-w-md mx-auto lg:max-w-none flex gap-3">{t4}{t5}</div></div>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}